import React, { useRef, useState } from "react";
import "./index.scss";
import downloadImageIcon from "../../../Assests/Images/uploadImage.svg";
import supportBotIcon from "../../../Assests/Images/supportBot.svg";
import DismissIcon from "../../../Assests/Images/Dismiss.svg";
import Button from "../../../SharableInputs/Button";
import Textarea from "../../../SharableInputs/Textarea";
import { v4 as uuidv4 } from "uuid";
import CustomAlert from "../Alert";
import DocumentOption from "../DocumentOption";

const SupportModalContent = ({ close, confirm }) => {
  const [showAlertMessege, setAlertMessege] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [query, setQuery] = useState("");
  const [showVerification, setShowVerification] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const submittingRef = useRef(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    setAlertMessege(null);
    const file = Array.from(event.target.files)[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result;
      const newkey = uuidv4();
      setSelectedFiles([
        ...selectedFiles,
        { base64String, file, key: newkey },
      ]);
    };
    reader.onerror = (error) => {
      console.error("File could not be read: ", error);
    };
    reader.readAsDataURL(file);
  };

  const deleteUploadedDoc = (file) => {
    const updatedFiles = selectedFiles.reduce((acc, cur) => {
      if (cur?.key !== file?.key) {
        acc.push(cur);
      }
      return acc;
    }, []);
    setSelectedFiles([...updatedFiles]);
  };

  const handleSubmit = async () => {
    if (submittingRef.current) return; 
    if (!query.trim()) {
      setSubmitError("Please describe your issue before sending.");
      return;
    }
    submittingRef.current = true;
    setSubmitError("");
    setSubmitting(true);
    try {
      const result = await confirm(query, selectedFiles);
      if (result?.ok) {
        setShowVerification(true);
        setTimeout(() => {
          setShowVerification(false);
          close();
        }, 2000);
        return;
      }
      setSubmitError(result?.message || "We couldn't send your message. Please try again.");
    } catch (err) {
      setSubmitError("We couldn't send your message. Please try again.");
    } finally {
      submittingRef.current = false;
      setSubmitting(false);
    }
  };

  return (
    <div className="support-wrapper">
      <div className="header-continer d-flex flex-column">
        <img
          src={DismissIcon}
          alt="logo"
          width={85}
          height={20}
          onClick={close}
          role="button"
          className="w-auto align-self-end"
        />
        <div className="header d-flex gap-4 align-items-center">
          <img
            src={supportBotIcon}
            alt="logo"
            width={60}
            height={60}
            className=""
          />
          <div>
            <p className="main-heading fw-bold fs-4">How can we help you!</p>
            <p className="sub-heading fs-6 fw-normal">
              Please provide your query or issue below, and we'll get back to
              you shortly.
            </p>
          </div>
        </div>
      </div>
      {showVerification ? (
        <div className="content p-4 d-flex flex-column gap-4 align-items-center justify-content-center">
          <img
            src={supportBotIcon}
            alt="verification"
            width={60}
            height={60}
            className="mb-3"
          />
          <p className="fw-bold fs-5 text-success text-center">
            Your message has been sent!
          </p>
          <p className="text-center">
            Thank you for contacting support. We'll get back to you soon.
          </p>
        </div>
      ) : (
        <>
          <div className="content p-4 d-flex flex-column gap-4">
            <Textarea
              placeholder="Enter here..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              name="notes"
              label="Describe Your Issue or Query"
            />
            <div>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <div className="mb-0 d-flex flex-wrap align-items-center">
                {selectedFiles?.length > 0 &&
                  selectedFiles?.map((file) => {
                    return (
                      <div
                        key={file?.file?.name}
                        className="mb-2 me-3 upload-document-input"
                      >
                        <DocumentOption
                          fileSrc={file?.base64String}
                          fileName={file?.file?.name}
                          deleteUploadedDoc={() => deleteUploadedDoc(file)}
                        />
                      </div>
                    );
                  })}
                <Button
                  label={selectedFiles?.length > 0 ? "Add More" : "Attach"}
                  onClick={() => fileInputRef.current.click()}
                  icon={
                    <img
                      src={downloadImageIcon}
                      alt="uploadIcon"
                      width={20}
                      height={20}
                    />
                  }
                  className="fw-bold"
                  type="button"
                  secondary={true}
                  border={true}
                />
              </div>
            </div>
          </div>
          <div className="footer p-4 d-flex flex-column gap-3">
            {submitError && (
              <p className="submit-error mb-0" role="alert">
                {submitError}
              </p>
            )}
            <div className="d-flex justify-content-end gap-3">
              <Button
                label="Cancel"
                onClick={close}
                className="fw-bold"
                type="button"
                secondary={true}
                border={false}
                isDisabled={submitting}
              />
              <Button
                primary={true}
                type="button"
                label={submitError ? "Try again" : "Submit"}
                isLoading={submitting}
                isDisabled={submitting || query.trim() === ""}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </>
      )}
      <CustomAlert
        message={showAlertMessege}
        type="error"
        isOpen={Boolean(showAlertMessege)}
        onClose={() => setAlertMessege(null)}
      />
    </div>
  );
};

export default SupportModalContent;